import { styleConfig as dls } from './dls-style-configs';

export { dls };
